export default "/images/62ed947887584b374da07938e05a6a01.avif";